import { render, staticRenderFns } from "./settingListPage.vue?vue&type=template&id=7a0a6d15&"
import script from "./settingListPage.vue?vue&type=script&lang=ts&"
export * from "./settingListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports